import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import {SnackbarContent, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import GoogleReCaptchaComponent from '../../common/ReCaptcha/GoogleReCaptchaComponent';

class ContactSupportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contact_name: !!this.props.auth ? this.props.auth.currentUser.displayName : "",
      contact_email: !!this.props.auth ? this.props.auth.currentUser.email : "",
      contact_phone: !!this.props.auth ? this.props.auth.currentUser.phoneNumber : "",
      message_body: "",
      message_being_sent: false,
    }
  }

  handler = (data) => {
    this.setState(data);
  }

  handleKeyPress = (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
  };

  submitContactUsForm = (e) => {
    e.preventDefault();
    this.setState(
      {
        message_being_sent: true,
      }
    )

    var set_state = (data) => {
      this.setState(data)
    }

    return this.props.sendEmail(
      {
        contact_name: this.state.contact_name,
        contact_email: this.state.contact_email,
        contact_phone: this.state.contact_phone,
        message: this.state.message_body,
        captcha_token: this.state.captcha_token,
      }
    )
      .then(json_response => {
        if (!json_response.success) {
          this.setState({ message_sent: 'error',
                          message_send_status: json_response.message,
                          message_being_sent: false,
                          notification_message_show: true
                        });
          return false;
        } else {
          this.setState({ message_sent: 'sent',
                          message_send_status: "Thank you! We've received your message and we'll reply back soon!",
                          notification_message_show: true,
                        })
          setTimeout(this.props.onOkClick, 3000);
          return true;
        }
      })
      .catch(error => {
        set_state({ message_sent: 'error',
                    message_send_status: "Sorry, we cannot send your message at this time :( Please try contacting us in another way.",
                    message_being_sent: false,
                    notification_message_show: true,
                  });
        console.log("Error sending message: ", error)
        return false;
      });

  }

  handleNameChange = (e) => {
    this.setState(
      {
        contact_name: e.target.value,
        notification_message_show: false,
      }
    )
  }
  
  handleEmailChange = (e) => {
    this.setState(
      {
        contact_email: e.target.value,
        notification_message_show: false,
      }
    )
  }

  handlePhoneChange = (e) => {
    this.setState(
      {
        contact_phone: e.target.value,
        notification_message_show: false,
      }
    )
  }

  handleMessageChange = (e) => {
    this.setState(
      {
        message_body: e.target.value,
        notification_message_show: false,
      }
    )
  }

  handleNotificationClose = () => {
    this.setState(
      {
        notification_message_show: false
      }
    )
  }

  render() {
    // Dialog Properties
    const { fullScreen, open } = this.props;

    // Custom Properties
    const { title, cancelText, okText, highlightOkButton } = this.props;

    // Dialog Events
    const { onClose, onExited } = this.props;

    // Custom Events
    const { onCancelClick, onOkClick } = this.props;

    if (!onClose) {
      return null;
    }
    
    return (
      <Dialog fullScreen={fullScreen} open={open} onClose={onClose} onExited={onExited} onKeyPress={this.handleKeyPress} maxWidth="md" fullWidth={true}>

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={!!this.state.notification_message_show}
        >
          <SnackbarContent
            sx={(theme) => this.state.message_sent === 'error' ?
              { backgroundColor: theme.palette.error.dark, color: "#ffffff", textAlign: "center" } :
              { backgroundColor: green[700], color: "#ffffff", textAlign: "center" }}
            aria-describedby="message_send_error"
            message={
            <span id="message_send_error" style={{display: 'flex', alignItems: 'center'}}>
                {this.state.message_send_status}
            </span>
            }
            action={[
              <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleNotificationClose}>
                <CloseIcon sx={{fontSize: 20}}/>
              </IconButton>,
            ]}
          />
        </Snackbar>

          <form onSubmit={this.submitContactUsForm}>

            <GoogleReCaptchaComponent component="support" handler={this.handler}/>

        {title && <DialogTitle>{title}
            <Hidden only={['md', 'lg', 'xl']}>
              <Button sx={{ position: "fixed", top: "20px", right: '20px' }}
                onClick={onCancelClick} variant="outlined" color="primary" size="small">X</Button>
            </Hidden>
        </DialogTitle>}


        <DialogContent dividers={true} sx={{marginBottom: '2rem', paddingBottom: '2rem', paddingTop: '2rem'}}>
            <Grid container spacing={3} direction="row" justify="center" alignItems="stretch" alignContent="stretch">
              <Grid item xs={12} >
                <Typography gutterBottom>
                  Need help? We'll reply as soon as possible!
                  Simply fill in the form below or get in touch via <a href="https://wa.me/447415092498" style={{textDecoration: 'none'}} target="_blank" rel="noopener noreferrer">
                    <Box component="span" sx={{ color: 'secondary.dark' }}>WhatsApp</Box></a> or <a href="https://t.me/dimileeh" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                    <Box component="span" sx={{ color: 'secondary.dark' }}>Telegram</Box></a>!
                </Typography>
              </Grid>
            </Grid>

            <Box>
              <Box>
                <TextField
                  id="display_name"
                  label="Name"
                  type='text'
                  required={true}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  placeholder="Jane Doe"
                  onChange={this.handleNameChange}
                  value={this.state.contact_name}
                />
              </Box>
              <Box>
                <TextField
                  id="email"
                  label="Email"
                  ref={this.emailInput}
                  required={true}
                  onChange={this.handleEmailChange}
                  name="email"
                  type="email"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  placeholder="jane.doe@example.com"
                  value={this.state.contact_email}
                />
              </Box>
              <Box>
                <TextField
                  id="phone"
                  label="Phone"
                  ref={this.phoneInput}
                  required={false}
                  onChange={this.handlePhoneChange}
                  name="phone"
                  type="phone"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  placeholder="+44 12 3456 7891"
                  value={this.state.contact_phone}
                />
              </Box>
              <Box>
                <TextField
                  id="message_body"
                  label="Your Message"
                  placeholder="How can we help you?"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  onChange={this.handleMessageChange}
                  multiline
                  rows="4"
                  rowsMax="10"
                  value={this.state.message_body}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Box>

        </DialogContent>

        {(onCancelClick || onOkClick) &&
          <DialogActions>
            {onCancelClick &&
              <Button color="primary" fullWidth={true} onClick={onCancelClick} variant="outlined">
                {cancelText || 'Cancel'}
              </Button>
            }

            {onOkClick &&
              <Button type="submit" color="primary" fullWidth={true} disabled={!this.state.contact_name || !this.state.contact_email || !this.state.message_body || !!this.state.message_being_sent} variant={highlightOkButton && 'contained'}>
                {okText || 'OK'}
              </Button>
            }
          </DialogActions>
        }
            </form>
      </Dialog>
    );
  }
}

ContactSupportDialog.propTypes = {
  fullScreen: PropTypes.bool,
  open: PropTypes.bool.isRequired,

  title: PropTypes.string,
  contentText: PropTypes.string,
  textField: PropTypes.element,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  disableOkButton: PropTypes.bool,
  highlightOkButton: PropTypes.bool,

  onClose: PropTypes.func.isRequired,
  onExited: PropTypes.func,
  onCancelClick: PropTypes.func,
  onOkClick: PropTypes.func
};

export default ContactSupportDialog;
